import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Image } from 'antd';
import { PROJECTS } from '../../utils/constants';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { BlurhashCanvas } from 'react-blurhash';
import './Project.css'; 
import { EyeOutlined } from '@ant-design/icons';
import { DescriptionContent } from '../utils/project-utils';

export const renderProjectsByType = (type, subType = null,limit=null) => (
    <div className="row g-4">
        {PROJECTS?.filter(project => 
            project.type === type && (!subType || project.subType === subType)
        )?.slice(0, limit || PROJECTS.length)?.map((project) => (
            <div key={project.id} className="col-md-6 col-lg-4">
                <Link className="text-decoration-none">
                    <Card
                        hoverable
                        className="h-100 shadow scale-hover-effect bg-dark text-light border-0"
                        style={{
                            backgroundColor: '#1f1f1f',
                            borderRadius: '8px',
                            overflow: 'hidden',
                        }}
                        cover={
                            <div className="image-wrapper">
                                {/* Placeholder for blurhash before image loads */}
                                <BlurhashCanvas
                                    hash={project.blurHash || 'LBA0?$WB00xu%LWBIVt700j[~qWB'} 
                                    punch={1}
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                    data-id={`blurhash-${project.id}`}
                                />

                                {/* Lazy load main image */}
                                <LazyLoadImage
                                    src={project?.img && project?.img.length > 0 && project.img[0]} 
                                    alt={project.title} 
                                    width="100%" 
                                    height="300px" 
                                    style={{ objectFit: 'cover' }}
                                    effect="blur"
                                    onClick={() => {
                                        document.querySelector(`[data-preview-id="${project.id}-0"]`).click();
                                    }}
                                    onLoad={() => {
                                        const blurHashElement = document.querySelector(`[data-id="blurhash-${project.id}"]`);
                                        if (blurHashElement) {
                                            blurHashElement.style.display = 'none';
                                        }
                                    }}
                                />

                                <div className="preview-overlay" onClick={() => {
                                    document.querySelector(`[data-preview-id="${project.id}-0"]`).click();
                                }}>
                                    <span className="preview-text"><EyeOutlined /> Preview</span>
                                </div>

                                <Image.PreviewGroup>
                                    {/* Invisible image to trigger the preview */}
                                    {project?.img && project.img.map((imageSrc, index) => (
                                        <Image
                                            key={index}
                                            src={imageSrc}
                                            style={{ display: index === 0 ? 'none' : 'block' }} // Hide first image but display others in preview group
                                            data-preview-id={`${project.id}-${index}`} // Unique identifier for programmatic trigger
                                        />
                                    ))}
                                </Image.PreviewGroup>
                            </div>
                        }
                    >
                        <Card.Meta
                            title={<h3 style={{ color: '#fff', textAlign: 'center', fontSize: '1.25rem', marginBottom: '0.5rem' }}>{project.title}</h3>}
                            description={ <DescriptionContent id={project.id} description={project.description} />}
                        />
                    </Card>
                </Link>
            </div>
        ))}
    </div>
);
